import React from 'react'
import { styled } from 'styletron-react'
import { padding, margin } from 'lostyle'
import { media, font, sizes, palette } from '../../style'

const InlineCode = styled('code', {
  ...padding({
    x: '6px',
  }),
  ...margin(0),
  backgroundColor: 'hsl(60,0%,95%)',
  transition: 'background-color 0.25s ease-in-out, border-color 0.25s ease-in-out',
  border: '1px solid hsla(0,0%,90%, 1)',
  fontFamily: font.monospace,
  fontSize: '14px',
  ...media('tablet', {
    ...padding({
      x: '6px',
      y: '2px',
    }),
  }),
  ':hover': {
    backgroundColor: 'hsla(60,100%,90%, 1)',
    borderColor: 'hsla(55,90%,80%, 1)',
  }
})
InlineCode.displayName = 'Code.InlineCode'

const Code = ({ value, inline, ...rest }) => <InlineCode {...rest}>{value}</InlineCode>

export default Code


// WEBPACK FOOTER //
// ./src/components/Code/index.js